var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 20.4824L14.9042 18.2922L16.761 16.1973L9.85733 10.3887L5.04852 12.674L3.42975 17.0543L6.00076 23.5295H6.04147L13.0196 20.5019L12.9997 20.4824Z",
    fill: "#BC9AF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7593 16.0858L16.7138 13.0781L13.8892 13.5948L16.7593 16.0858Z",
    fill: "#6864F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.761 16.198L18.1418 18.5786L14.9042 18.2929L13.6663 13.627L16.761 16.198Z",
    fill: "#6864F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0945 23.5303L13.0268 20.5098L6.23059 23.5303H16.0945Z",
    fill: "#6864F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7942 21.0331L6.04127 23.5291H6.0008L3.4295 17.0538L5.04833 12.6735L6.40409 12.0293C6.29021 12.5606 6.23045 13.1135 6.23045 13.6806C6.23045 17.2509 8.60362 20.2434 11.7942 21.0331Z",
    fill: "#6864F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2855 5.43706L8.15585 0.470703L6.95764 4.86407L13.2855 5.43706Z",
    fill: "#6864F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2854 5.43643L3.28699 1.3418L3.62026 4.38895L5.04859 6.10297L10.524 9.43582L13.2854 5.43643Z",
    fill: "#FD7DA0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2855 5.4375L20.7129 9.77016L19.6178 12.484L13.6188 13.6267L9.85742 10.3891L13.2855 5.4375Z",
    fill: "#BC9AF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 20.4824L6.00085 23.5296",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2855 5.43706L8.15587 0.470703L7.49945 2.87757",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9043 18.2927L12.9998 20.4828L16.0946 23.53H6.00082L3.42981 17.0548L5.04859 12.6745L9.85739 10.3891L13.2854 5.4375L20.7129 9.77016L19.6178 12.484L16.7135 13.0554L16.7611 16.1977",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7135 13.0547L13.6188 13.626",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85742 10.3887L16.7611 16.1973L18.1419 18.5779L14.9043 18.2922L13.6664 13.6263",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2854 5.43643L3.28699 1.3418L3.62026 4.38895L5.04859 6.10297L10.524 9.43582",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8232,
    cy: 9.43739,
    r: 0.470588,
    fill: "#052A75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2197 10.7617H20.2844",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon9);
export default __webpack_public_path__ + "static/media/assistant-icon-9.178c45498c116102412716431d2d15a6.svg";
export { ForwardRef as ReactComponent };